const productHeroes = document.querySelectorAll('.product-hero');
const productHeroController = new ScrollMagic.Controller();

productHeroes.forEach((el) => {
  const heroBackground = el.querySelector('.product-hero__background-inner');

  // Background animation
  const stickyTween = gsap.to(heroBackground, {
    yPercent: windowWidth() < breakpointMd ? 30 : 60,
    autoAlpha: 0.4,
  });

  new ScrollMagic.Scene({
    triggerElement: el,
    triggerHook: 0,
    duration: '200%',
  })
    .setTween(stickyTween)
    .addTo(productHeroController);
});
